import store from "@/store";

export default {
  methods: {
    $allowed(permissionNames = [], roleNames = ["super-admin", "admin"]) {
      let perms = store.state.auth.security.permissions;
      let roles = store.state.auth.security.roles;

      if (!Array.isArray(permissionNames)) {
        permissionNames = [permissionNames];
      }

      let hasRole = roleNames.some(p => roles?.includes(p));
      let hasPermission = permissionNames.some(p => perms?.includes(p));

      return hasRole || hasPermission;
    },

    $hasRole(roleNames = []) {
      let roles = store.state.auth.security.roles;

      if (!Array.isArray(roleNames)) {
        roleNames = [roleNames];
      }

      let hasRole = roleNames.some(p => roles?.includes(p));
      return hasRole;
    }
  }
};
